export default "__VITE_ASSET__8663696c__"